import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapGetters, mapActions, mapState } from "vuex";
import { CURRENT_USER_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import { asyncValidation } from "@Shared/utils/validation-rules";
import { LOAD_SYNCED_EMAILS } from "@Broker/@Modules/settings/store/settings-actions";
export default {
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_DETAILS])), mapState("SettingsStore", {
    M_syncedEmails(state) {
      const emails = state.syncedEmails.allIds || [];
      return _mapInstanceProperty(emails).call(emails, accountId => state.syncedEmails.emails[accountId].email);
    }
  })), {}, {
    M_accountEmail() {
      return this.CURRENT_USER_DETAILS.email;
    }
  }),
  data() {
    return {
      M_loadedSyncedEmails: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_SYNCED_EMAILS])), {}, {
    validation_notCurrentAccountEmail(value) {
      return this.M_accountEmail !== value;
    },
    async validation_notConnectedAccountEmail(value) {
      if (!value) return true;
      return await asyncValidation(value, async email => {
        var _context;
        if (!this.M_loadedSyncedEmails) {
          await this.LOAD_SYNCED_EMAILS();
          this.M_loadedSyncedEmails = true;
        }
        return !_includesInstanceProperty(_context = this.M_syncedEmails).call(_context, email);
      });
    }
  })
};